import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '../../components/loading/Loading';
import Timeline from '../../components/timeline/Timeline';
import { generateDefaultActivity } from '../../utilities/activity';
import { isStaff } from '../../utilities/user';
import JobActivity from './JobActivity';
import { useGetProjectQuery } from '@/redux/rtk';
import useUser from '@/mp/hooks/useUser';
import useActivityFilters from '../../hooks/useActivityFilters';
import { activityFilters } from './ActivityFilterControls';

const JobTimeline = () => {
  // TODO: confusing, projectId vs currentProject?
  const { currentProject, isStaffActivityListVisible } = useSelector(
    (state) => ({
      isStaffActivityListVisible: state.activity.isStaffActivityListVisible,
      currentProject: state.project.currentProject,
    })
  );
  const { projectId } = useParams();

  const currentUser = useUser();
  const { data: project, ...getProject } = useGetProjectQuery({
    projectId,
    params: { includeActivities: true },
  });

  const { filteredActivities } = useActivityFilters(
    project?.activities,
    activityFilters
  );

  const rawActivities = useMemo(
    () =>
      [...filteredActivities]?.sort((a, b) => {
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        return dateB - dateA;
      }),
    [filteredActivities]
  );

  const activities = isEmpty(rawActivities)
    ? [generateDefaultActivity()]
    : filter(rawActivities, (activity) => {
        const visibilityFilter = !isStaffActivityListVisible
          ? !isStaff(activity?.visibility)
          : true;

        const hiddenFilter =
          currentUser.isStaff || currentUser.isAdmin
            ? true
            : !activity?.is_hidden;

        return visibilityFilter && hiddenFilter;
      });

  // TODO: refactor job to project timeline and activity
  return (
    <Timeline className='JobTimeline'>
      {getProject.isLoading ? (
        <Loading />
      ) : (
        activities?.map((activity, i) => (
          <JobActivity
            key={i}
            currentProject={currentProject}
            jobActivity={activity}
          />
        ))
      )}
    </Timeline>
  );
};

export default JobTimeline;
